<template>
  <div>
<!--    <div v-if="isShowPage">-->
      <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
        <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline" @keydown.native.enter="handleSearchBtn">
          <div id="searchBox">
            <el-form-item prop="xhname">
            <el-select
              ref="selectRef"
              @change="handleChange"
              class="model-select"
              style="margin-bottom: 10px"
              v-model="keyword"
              filterable
              remote
              popper-append-to-body
              reserve-keyword
              :automatic-dropdown="true"
              :default-first-option="true"
              placeholder="请输入轴承型号"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
              {{ word }}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
            <el-button type="primary" size="small" @click="handleSearchBtn()" icon="el-icon-search">搜索
            </el-button>
            <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <div class="custom-table search-table">
        <el-table border fit highlight-current-row class="customer-table" :data="list">
          <el-table-column label="序号" prop="">
            <template #default="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="订单号" prop="orderid"></el-table-column>
          <el-table-column label="型号" prop="xhname"></el-table-column>
          <el-table-column label="品牌" prop="source"></el-table-column>
          <el-table-column label="数量" prop="num"></el-table-column>
          <el-table-column label="单价" prop="price"></el-table-column>
          <el-table-column label="总价" prop="zprice"></el-table-column>
          <el-table-column label="货期" prop="hq"></el-table-column>
          <el-table-column label="是否含税" prop="kpzt"></el-table-column>
          <el-table-column label="负责人" prop="rname"></el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                       :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
      </div>
    </div>
<!--    <el-empty description="暂无权限查看数据" v-else class="customer-category_empty" />-->
<!--  </div>-->
</template>
<script>
import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'


export default defineComponent({
  components: { PageWrapper },
  props: {
    activeName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showAll = ref(false)
    const isShowPage = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const list = ref([])

    const searchFormRef = ref(null)
    const searchForm = reactive({
      xhname: '',
    })

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const companyId = ref('')

    onMounted(()=>{
      companyId.value = instance.proxy.$route.params.id
      getList(companyId.value)
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getList(companyId.value)
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getList(companyId.value)
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getList(companyId.value)
    }

    const handleResetBtn = () => {
      keyword.value = ''
      searchForm.xhname = ''
      getList(companyId.value)
    }


    const getList = (companyId) => {
      request({
        url: 'ci_switch.yy',
        method: 'post',
        params: selectPage,
        data: {
          id: companyId,
          ...searchForm,
        }
      }).then(res => {
        if (res.code == 200) {
          list.value = res.data
          allNum.value = res.total
          isShowPage.value = true
        } else if (res.code == 400) {
          isShowPage.value = false
          Message({ type: 'error', message: res.msg })
        }
      })
    }

    const options = ref([])
    const loading = ref(false)
    const keyword = ref('')//搜索型号关键字
    //远程搜索型号方法
    const remoteMethod = async (query) => {
      if (!query) {
        options.value = []
        return
      }
      loading.value = true
      try {
        const { data } = await request({
          url: 'ci_queryxh.yy',
          method: 'post',
          data: { xhname: query, id: companyId.value }
        })

        options.value = data.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('搜索失败', error)
      } finally {
        loading.value = false
      }
    }

    //模糊下拉型号选中请求接口
    const handleChange = (xh) => {
      searchForm.xhname = xh
      getList(companyId.value)
    }


    return {
      options,
      loading,
      keyword,
      companyId,
      isShowPage,
      username,
      searchFormRef,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      list,
      remoteMethod,
      handleChange,
      closeSearch,
      handleResetBtn,
      handleSearchBtn,
      pageSizeChange,
      pageCurrentChange,
    }
  }
})
</script>


